import { ResizablePanelGroup, ResizablePanel, ResizableHandle } from '@/components/ui/resizable';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ChatPanel } from '@/components/chat/ChatPanel';
import { CanvasPanel } from '@/components/canvas/CanvasPanel';

const StudioPage = () => {
  const { t } = useTranslation();
  return (
    <div className="h-[calc(100vh-theme(spacing.20))] flex flex-col p-4 md:p-6">
      <ResizablePanelGroup direction="horizontal" className="flex-grow h-0 min-h-0 rounded-lg border">
        <ResizablePanel defaultSize={30} minSize={20}>
          <Card className="h-full flex flex-col">
            <CardHeader>
              <CardTitle>{t('chat.title')}</CardTitle>
            </CardHeader>
            <CardContent className="flex-grow min-h-0 p-0 overflow-y-auto">
              <ChatPanel />
            </CardContent>
          </Card>
        </ResizablePanel>
        <ResizableHandle withHandle />
        <ResizablePanel defaultSize={70} minSize={40}>
          <Card className="h-full flex flex-col">
            <CardHeader>
              <CardTitle>{t('canvas.title')}</CardTitle>
            </CardHeader>
            <CardContent className="flex-grow min-h-0 p-0 overflow-y-auto">
              <CanvasPanel />
            </CardContent>
          </Card>
        </ResizablePanel>
      </ResizablePanelGroup>
    </div>
  );
};

export default StudioPage;
